<template>
    <section class="dispatchOrder-table">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                :disabled="!selectList.length"
                @click="handleConserve"
            >
                明细保存
            </el-button>
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="handleRefresh"
            >
                刷新
            </el-button>
        </div>
        <m-pane
            ref="tablePage"
            :control="false"
            :tableData="totalData"
            :columns="config.columns"
            :height="config.height"
            :selection="config.selection"
            :loading="loading"
            @selection-change="handleSelectionChange"
            @btn-event="handleAction"
        >
        </m-pane>
        <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page>
    </section>
</template>
<script>
import mPane from './EditTable.vue';
import mPage from '@/components/otpPanel/mPage';
import { queryLoadCarDetailPage, saveDetailLoadInfo } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { config } from './config.js';
// import { formatSearchData, validateSearchData } from './util';

export default {
    name: 'dispatchDetailedLoadingTable',
    components: { mPane, mPage },
    props: {
        componentsModalData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            selected: [], // 选中数据
            totalData: [], // 列表数据
            selectList: [], // 复选框选中数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            dictData: {}, // 数据字典集合
            pageTotal: 0,
            currentPage: 1,
            optionNum: 'SYS_WM_ASN_STATUS,SYS_WM_SO_STATUS',
            componentsName: ''

        };
    },
    mounted () {
        this.getList();
    },
    methods: {
        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            const obj = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                param: {
                    taskNo: this.componentsModalData.taskNo
                }
            };
            this.loading = true;
            queryLoadCarDetailPage(obj).then((res) => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list;
                    this.page.pageNo = res.data.pageNo;
                    this.page.pageSize = res.data.pageSize;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        /**
         * @description 表单操作栏事件
         * @param selection 操作参数
         * @param event 操作事件名称
        */
        handleAction (selection, event) {
            if (event === 'save') {
                this.loading = true;
                saveDetailLoadInfo({
                    detailList: [
                        {
                            actQty: selection.actQty,
                            id: selection.id
                        }
                    ],
                    taskNo: this.componentsModalData.taskNo
                }).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '保存成功');
                    }
                }).finally(() => {
                    this.getList();
                    this.loading = false;
                });
            }
        },
        /**
         * @description 复选框勾选
        */
        handleSelectionChange (selection) {
            this.selectList = selection;
        },
        /**
         * @description 明细保存
        */
        async handleConserve () {
            const { tableExamine } = this.$refs.tablePage;
            if (!tableExamine(this.selectList)) return;
            const detailList = this.selectList.map(item => {
                return {
                    actQty: item.actQty,
                    id: item.id
                };
            });
            saveDetailLoadInfo({
                detailList: detailList,
                taskNo: this.componentsModalData.taskNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '保存成功');
                }
            }).finally(() => {
                this.getList();
                this.loading = false;
            });
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        }
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
.dispatchOrder-table .dispatch-table-header {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}
</style>
